const getNetworkSpeed = (): number => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore using outdated browser dom api's
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
  // @ts-ignore todo proper types to be added
  return Math.round(connection?.downlink || 10)
}

type TransformOptions = {
  blur?: number
  progressive?: false
  width?: number
  height?: number | ((w: number) => number)
  mobile?: boolean
  format?: 'webp'
  quality?: number
  optimize?: boolean
  disableResize?: boolean
}

export const imageTransform = (url: string, options: TransformOptions = {}): string | null => {
  // extract url
  const match = (url || '').match(/\/(?<imageId>[\w\d]+)$/)
  if (!(url || '').includes('cdn.buttercms.com') || !match?.groups?.imageId) {
    // skip transformation
    return null
  }
  const {imageId} = match.groups
  const urlParts = ['https://cdn.filestackcontent.com']
  const transformOptions = []
  if (options.blur) {
    transformOptions.push(`blur=amount:${options.blur}`)
  }
  if (options.quality) {
    transformOptions.push(`quality=value:${options.quality}`)
  } else if (options.blur) {
    transformOptions.push(`quality=value:80`)
  }
  if (options.progressive) {
    if (getNetworkSpeed() <= 1) {
      transformOptions.push(`pjpg=quality:100`)
    }
  }
  transformOptions.push('compress')

  if (options.optimize) {
    transformOptions.push('auto_image')
  }

  if (!options?.disableResize) {
    const resizeOpts = []

    if (options.width) {
      resizeOpts.push(`width:${options.width}`)
    } else {
      resizeOpts.push(`width:1080`)
    }
    if (options.height) {
      if (typeof options.height === 'number') {
        resizeOpts.push(`height:${options.height}`)
      } else if (typeof options.height === 'function') {
        resizeOpts.push(`height:${options.height(options.width || 1080)}`)
      }
      resizeOpts.push('fit:crop')
    }
    if (resizeOpts.length > 0) {
      transformOptions.push(`resize=${resizeOpts.join(',')}`)
    }
  }

  if (options.format) {
    transformOptions.push(`output=format:${options.format}`)
  }
  transformOptions.push(imageId)

  return `${urlParts.join('/')}/${transformOptions.join('/')}`
}
